const getSeconds = (hours: string, minutes: string): number =>
  (Number(hours || 0) * 60 + Number(minutes || 0)) * 60;

export default getSeconds;
